import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatCardModule } from '@angular/material/card';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSnackBar, MatSnackBarModule } from '@angular/material/snack-bar';
import { CelebrationService } from '../../core/services/celebration.service';
import { MeuLocalService } from '../../core/services/meu-local.service';
import { Celebration, CelebrationJob, CelebrationJobLocation } from '../../core/models/event.model';
import { environment } from '../../../environments/environment';

/**
 * Seleção do local que o usuário comanda. Reutilizado como página
 * (menu "Meu Local") e dentro do modal pós-login.
 */
@Component({
  selector: 'app-meu-local',
  standalone: true,
  imports: [
    CommonModule, FormsModule, MatCardModule, MatFormFieldModule, MatSelectModule,
    MatButtonModule, MatIconModule, MatProgressSpinnerModule, MatSnackBarModule,
  ],
  templateUrl: './meu-local.component.html',
  styleUrls: ['./meu-local.component.scss'],
})
export class MeuLocalComponent implements OnInit {
  /** Quando true, renderiza no modo enxuto do modal (mostra botão "Deixar em branco"). */
  @Input() isDialog = false;
  /** Emitido ao concluir (salvar ou pular) no modo modal. */
  @Output() done = new EventEmitter<void>();

  jobs: CelebrationJob[] = [];
  selectedLocationUuid = '';
  isLoading = false;
  error: string | null = null;

  constructor(
    private readonly celebrationService: CelebrationService,
    private readonly meuLocalService: MeuLocalService,
    private readonly snackBar: MatSnackBar,
  ) {}

  ngOnInit(): void {
    this.selectedLocationUuid = this.meuLocalService.meuLocal?.locationUuid ?? '';
    this.carregarJobs();
  }

  get localAtual(): CelebrationJobLocation | null {
    return this.meuLocalService.meuLocal;
  }

  carregarJobs(): void {
    this.isLoading = true;
    this.error = null;
    this.celebrationService.getCelebrationById(environment.FIXED_EVENT.uuid).subscribe({
      next: (celebration: Celebration) => {
        this.jobs = celebration.jobList ?? [];
        this.isLoading = false;
      },
      error: () => {
        this.error = 'Erro ao carregar as funções/postos.';
        this.isLoading = false;
      },
    });
  }

  salvar(): void {
    const local = this.encontrarLocal(this.selectedLocationUuid);
    if (!local) {
      this.snackBar.open('Selecione um local para salvar.', 'OK', { duration: 3000 });
      return;
    }
    this.meuLocalService.setMeuLocal(local);
    this.snackBar.open(`Meu local definido: ${local.name}`, '', { duration: 2500 });
    this.done.emit();
  }

  limpar(): void {
    this.meuLocalService.limpar();
    this.selectedLocationUuid = '';
    this.snackBar.open('Meu local removido.', '', { duration: 2500 });
  }

  /** Modo modal: fecha sem alterar o local salvo. */
  pular(): void {
    this.done.emit();
  }

  private encontrarLocal(locationUuid: string): CelebrationJobLocation | null {
    for (const job of this.jobs) {
      const found = job.locationList.find(l => l.locationUuid === locationUuid);
      if (found) return found;
    }
    return null;
  }
}
